import { styled } from 'styled-components';

export const PlayFinderSummaryBarsWrapper = styled.svg`
  max-height: 89px;
`;
